module.exports = __webpack_public_path__ + "img/win_line.dc35bdce.png";